import {useCheckoutStore} from "@/checkout/stores/checkout.store.ts";
import * as Sentry from "@sentry/vue";

export function useCheckoutFunctions() {
    const checkout = useCheckoutStore();

    const cancelCheckout = async (event:any) => {
        event.preventDefault();

        try {
            await checkout.cancel();
            document.location.href = checkout.config.basketReturn.url;
        } catch (error) {
            // Log the error to Sentry
            Sentry.captureException(error);
            console.error("Failed to cancel checkout:", error);
        }
    }
    return {
        cancelCheckout
    }
}